import { render, staticRenderFns } from "./roam-product.vue?vue&type=template&id=0c8ee261&"
import script from "./roam-product.vue?vue&type=script&lang=js&"
export * from "./roam-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports